import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import { Route as userListRoute } from "../index";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import getPharmacyID from "@/utils/pharmacy_code";
import { useRouter } from "@tanstack/react-router";
import { toast } from "@/components/ui/use-toast";
import { pharmacyClient } from "@/connect";

const AddMember = () => {
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [username, setUsername] = useState("");
  const [userRoles, setUserRoles] = useState({
    admin: false,
    superadmin: false,
    employee: false,
    inventory: false,
    sales: false,
  });
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  const handleAddUser = async () => {

    try {
      const response = await pharmacyClient.createUser({
        username: username,
        firstName: userFirstName,
        lastName: userLastName,
        email: userEmail,
        pharmacyCode: getPharmacyID() || "",
      });

      if (response.success) {
        router.invalidate();
        setIsOpen(false);
        
        // Reset form
        setUserFirstName("");
        setUserLastName("");
        setUserEmail("");
        setUsername("");
        setUserRoles({
          admin: false,
          superadmin: false,
          employee: false,
          inventory: false,
          sales: false,
        });

        toast({
          title: "User Added",
          description: response.message,
          variant: "default",
          duration: 5000,
        });
      }
    } catch (error) {
      console.error("Failed to add user:", error);
      toast({
        title: "Error",
        description: "Failed to create user. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">Add User</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add New User</DialogTitle>
          <DialogDescription>
            Fill in the details to add a new user to your team.
          </DialogDescription>
        </DialogHeader>
        
          <div>
            <Label htmlFor="username">Username</Label>
            <Input
              id="username"
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="Enter user email"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
            />
          </div>

          <div>
            <Label htmlFor="first-name">First Name</Label>
            <Input
              id="first-name"
              type="text"
              placeholder="Enter user first name"
              value={userFirstName}
              onChange={(e) => setUserFirstName(e.target.value)}
            />
          </div>

          <div>
            <Label htmlFor="last-name">Last Name</Label>
            <Input
              id="last-name"
              type="text"
              placeholder="Enter user last name"
              value={userLastName}
              onChange={(e) => setUserLastName(e.target.value)}
            />
          </div>


        <DialogFooter>
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button onClick={handleAddUser}>Add User</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

const Manage = () => {
  const data = userListRoute.useLoaderData();
  const user = localStorage.getItem("user");
  const userData = user ? JSON.parse(user).roles : null;

  const canManageUsers = userData?.access_levels?.includes("WRITE") ?? true;

  return (
    <>
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Manage Members</h2>
          <p className="text-muted-foreground">
            Invite your team members to collaborate.
          </p>
        </div>
        {canManageUsers && <AddMember />}
      </div>

      <hr className="my-4" />

      <div className="flex flex-col gap-y-4">
        {data.users.map((user) => (
          <div key={user.user_id} className="flex justify-between items-center p-4 border rounded-lg">
            <div>
              <p className="font-medium">{user.full_name}</p>
              <p className="text-sm text-muted-foreground">@{user.username}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Manage;